import { useTranslation } from 'react-i18next';
import { useState, useEffect, useContext, useRef, forwardRef, useImperativeHandle } from 'react';
import InputWrapperRefacture from '../../UI/Inputs/InputWrapperRefacture';
import Dropdown from '../../UI/Dropdown/Dropdown';
import { Company } from '../../Checkout/Company/Company';
import AddressSearch from 'react-loqate';
import SearchDropdown from '../../UI/Dropdown/SearchDropdown';
//import 'react-loqate/dist/react-loqate.cjs.development.css';
import '../../../i18n'
import { PaymentFormContext, updateBillingAddress, updateBillingCompany } from '../PaymentFormReducer';
import { checkIsBlank } from '../../Utilities/FieldValidations';
import ErrorBox from '../../UI/ErrorBox/ErrorBox';
import { APIGet, getEnvironment } from '../../API/APIRequest';
import { AddressFields } from './AddressFields';
import { format } from 'react-string-format';
import { UpdateBasket } from './Basket';
import { LatestAddress } from './LatestAddress';
import { getFilteredValues } from '../../Utilities/Functions';
import { AddressBlock } from '../../Utilities/AddressManagementUtils';


export const BillingDetails = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const { flags, 
        deliveryCountryCode, 
        showCompany, 
        setBasketErrors, 
        purchasingFor, 
        setBasket, basket, 
        fid, 
        loqateKey, 
        vatDetails, 
        setBillingCountryCode,
        billingCountryCode, 
        deliveryAddress, 
        IsFilledDelivery, 
        selectedAddress, 
        selectedCompany, 
        setSelectedAddress, 
        setSelectedCompany, 
        deliveryCompany, 
        IsFilled, 
        setIsFilled, 
        deliveryAddressStructure, 
        updateAndRefreshBasket, 
        errorStates, 
        setErrorStates, 
        setcompanyProperties,
        invalidState, 
        setInvalidState,
        billingSectionLoading,
        setBillingSectionLoading,
        latestBillingDetails,
        usingLatestBillingDetails,
        setUsingLatestBillingDetails,
        usingLatestDeliveryDetails
        } = props;
    
    const [isChecked, setIsChecked] = useState(true);

    const [country, setCountry] = useState({});
    const [countryCode, setCountryCode] = useState("");
    const [initialFilledState, setInitialFilledState]=useState({});
    const [initialInvalidState, setInitialInvalidState]=useState({});
    const [addressStructure, setAddressStructure] = useState([])
    const [companyProperties, setCompanyProperties] = useState(props.companyProperties)
    const formRef = useRef(null);
    const [countryList, setCountryList] = useState([]);
    const [environment, setEnvironment] = useState(getEnvironment());
    const [hasVatChanged, setVatChanged] = useState(null);
    const [fieldsLoading, setFieldsLoading] = useState(false);
    const [textForScreenReader, setTextForScreenReader] = useState('');
    const [editMode, setEditMode] = useState(false);
   
    
    const getCountryList = async () => {
        if(sessionStorage.getItem("countryList")){
           const list =  JSON.parse(sessionStorage.getItem("countryList"));
           setCountryList(list||[]);
          return;
        }

        return APIGet({
            "controller": "country",
            "action": "getcountries",
            "environment": environment,
            "identifier": null
        }).then((response) => {
            response.data.countries.sort((a, b) => {
                if (a.countryname < b.countryname) return -1;
                if (a.countryname > b.countryname) return 1;
                return 0;
              });
             
            sessionStorage.setItem("countryList", JSON.stringify(response.data.countries))
            setCountryList(response.data.countries)
        }).catch((errors) => {
            
        });
    }

   
    const getAddressStructure = async (value, basketId) => {
        
        //initializing the state again
        setInitialFilledState({ COUNTRY: { filled: true, mandatory: true }})
        
        return APIGet({
            "controller": "country",
            "action": "getaddressstructure",
            "environment": environment,
            "identifier": value?.toLowerCase(),
            "data": {
                basketId: basketId
            }
        }).then((response) => {
            let addressfields = response.data.addressfields;
            let filteredFields = addressfields.filter(item=> item.fieldName !=="JOBTITLE" && item.fieldName !== "DEPARTMENT"); //removing jobtitle and department fields
            let companyField = addressfields.find((item) => (item.fieldName === "COMPANY"));
         
            
              setAddressStructure(filteredFields);

              if(companyField && showCompany){
                  if(basket?.offertypename==="corporate subscription"){
                    setIsFilled(IsFilled => ({ ...IsFilled, COMPANY: { filled: true, mandatory: true } }));
                  }
                  else{
                    setIsFilled(IsFilled => ({ ...IsFilled, COMPANY: { filled: true, mandatory: companyField?.mandatory } }));
               }}
               
              if(basket?.offertypename==="corporate subscription"){
                setCompanyProperties({...companyField, mandatory: true }); 
              }
              else{
                setCompanyProperties(companyField); 
              }
            
             if (flags.collectbillingaddress) {
                addressFieldsMap(filteredFields)
             }

        }).catch((errors) => {
          
        });
    }
    
    const addressFieldsMap = (addressfields) => {
        addressfields.map((field, index) => {
          if (field.fieldName !== "COUNTRY") {
            //so that on state change from manual to lookup we can retain the original isFilled state
            setInitialFilledState(initialFilledState => ({...initialFilledState, [field.fieldName]: { ...initialFilledState[field.fieldName], filled: true, mandatory: field.mandatory } }));
            setInitialInvalidState(initialInvalidState => ({...initialInvalidState, [field.fieldName]: { ...initialInvalidState[field.fieldName], invalid: false, mandatory: field.mandatory } }));
            }
        })
      }


    useEffect(() => {

        if(!usingLatestBillingDetails){

        if (!countryList.length) {
            getCountryList();
        }
        if (deliveryAddress.COUNTRY) {
          setSelectedAddress({ ...selectedAddress, COUNTRY: deliveryAddress?.COUNTRY })
          setIsFilled(IsFilled => ({ ...IsFilled, COUNTRY: { filled: true, mandatory: true } }));
            
        }
        if (deliveryCompany.COMPANY) {
            setSelectedCompany({
                COMPANY: deliveryCompany?.COMPANY,
                CompanyId: deliveryCompany?.CompanyId || null
              });
        }
        if (deliveryCountryCode) {
            setCountryCode(deliveryCountryCode)
        }

        setEditMode(true)

    }

    }, [usingLatestBillingDetails])  

   //if no postal address is req then using delivery country code to fetch address structure in billing
    useEffect(() => {
      setCountryCode(deliveryCountryCode);
    }, [deliveryCountryCode]);

    useEffect(() => {
        
       setAddressStructure(deliveryAddressStructure);
       addressFieldsMap(deliveryAddressStructure);
            
    }, [deliveryAddressStructure]);

    useEffect(()=>{

        if(basket.offertypename === "corporate subscription"){
            setCompanyProperties({...props?.companyProperties, mandatory: true});
       }else{
            setCompanyProperties(props?.companyProperties)
        }
     }, [props?.companyProperties])



    useEffect(()=>{
        setBillingCountryCode(countryCode)
    },[countryCode])


    
    useEffect(() => {
        if (deliveryAddress?.COUNTRY && !usingLatestBillingDetails) {
            setSelectedAddress({ ...selectedAddress, COUNTRY: deliveryAddress?.COUNTRY })
            setIsFilled({ ...IsFilled, COUNTRY: { filled: true, mandatory: true } })
         
        }
    }, [deliveryAddress?.COUNTRY,  usingLatestBillingDetails])


   //when checkbox is there on DOM
    useEffect(() => {
       
        if(editMode){

          if(flags.collectbillingaddress && !usingLatestBillingDetails){

           if (isChecked) {
         
            setAddressStructure(deliveryAddressStructure);
            setCountryCode(deliveryCountryCode);

            if(basket?.origincountrycode !== deliveryCountryCode){
             // Use "sameAsDelivery" case setting country code and county code to update basket
             updateAndRefreshBasket(deliveryCountryCode,"sameAsDelivery");
            } else if (basket?.destinationcountycode && basket?.origincountycode !== basket?.destinationcountycode) {
                // when country is matching only need to pass county code
                updateAndRefreshBasket("", "origincountycode", "", basket?.destinationcountycode);
            }

            setSelectedAddress(deliveryAddress);
            setSelectedCompany(deliveryCompany);

            if(basket.offertypename === "corporate subscription"){
                setIsFilled(IsFilledDelivery => ({ ...IsFilledDelivery, COMPANY: { filled: true, mandatory: true } }));
            }else{
                setIsFilled(IsFilledDelivery);
            }
        }
        else {
            setSelectedAddress({ COUNTRY: deliveryAddress?.COUNTRY })
            setSelectedCompany({COMPANY: "", CompanyId:null })

       }}else{
            setSelectedAddress({ COUNTRY: deliveryAddress?.COUNTRY })
            setSelectedCompany(deliveryCompany);
       }}

    }, [isChecked, editMode, usingLatestBillingDetails])

    
    //on selection of country we need address structure from database
    const handleOnCountrySelect = (value) => {
       
        if (value?.countrycode && (countryCode !== value?.countrycode)) {
        setBillingSectionLoading(true);
        setCountry(value);
        updateAndRefreshBasket(value.countrycode,"origincountrycode");
        getAddressStructure(value?.countrycode, fid)
        setIsFilled({COUNTRY: { ...IsFilled.COUNTRY, filled: true } })
        setCountryCode(value?.countrycode)
        setSelectedAddress({COUNTRY: value?.countryname })  //blanking out the obj data except for country
        }
    }

    

    let countryField = <> <div className="item-container">
        <div className="item-wrapper">
            <SearchDropdown
                label={t('checkout.billingcountrylabel')}
                optionLabel={t('placeholder.addresssearchdropdown')}
                id="billing-country"
                name="billing-country"
                type="text"
                inputFieldType="text"
                aria-describedby="billing-country-error"
                inputSize="full-width"
                invalidClass={IsFilled.COUNTRY && !IsFilled?.COUNTRY?.filled && "Invalid-input"}
                aria-invalid={IsFilled.COUNTRY && !IsFilled?.COUNTRY?.filled}
                setValue={handleOnCountrySelect}
                val={selectedAddress.COUNTRY}
                options={countryList && countryList}
                dropdownName="country"
                keyProperty="countrycode"
                nameProperty="countryname"
                valueProperty="countrycode"
            />
        </div>
        {IsFilled.COUNTRY && !IsFilled?.COUNTRY?.filled &&
            <span role="alert" id="country-errors">
                <ErrorBox>{format(t('addressfields.blankerrortext'), "country")}</ErrorBox>
            </span>}
    </div>
    </>

    // const deliveryAddressOptional = () => {
    //     // Get an array of [key, value] pairs
    //     const entries = Object.entries(props?.deliveryAddress).filter(([key, value]) => key !== 'SOURCE' && key!=='COUNTYUID');
    //     // const twoEntry = entries.find(([key, value]) =>  key='COUNTRY'); 
    //     // Add the 'two' entry to the end of the filtered entries
    //     // if (twoEntry) {
    //     //     entries.shift(twoEntry);
    //     //      entries.push(twoEntry);
    //     // }
    //     return (
    //         <>
    //             <p><strong>{t('billingdetails.billingaddress') }</strong></p>
    //             <p>
    //             {props.deliveryCompany.COMPANY ? props.deliveryCompany.COMPANY + '\n'  : '' }  
    //             {entries.map(([key, value], index) => (

    //                <>
    //                      {value}
    //                     {index < entries.length - 1 && <br/>}
    //                 </>
    //             ))} 
    //             </p>
    //         </>
    //     )
    // }

const billingAddressUI = () => (
  <AddressBlock
    address={selectedAddress}
    company={selectedCompany}
  />
);

    useEffect(() => {

        if (billingSectionLoading) {

            const timeout = setTimeout(() => {
                setTextForScreenReader('Billing section is loading, please wait.');
            }, 50);

            return () => clearTimeout(timeout);

        } else {
            setTextForScreenReader('');
        }

    }, [billingSectionLoading]);

    const handleOnEdit=()=>{


        setUsingLatestBillingDetails(false);        
        setEditMode(true);
 
   }
   
    useEffect(() => {

       if (!flags?.collectbillingaddress) {
         setUsingLatestBillingDetails(false)
       }

       if(!flags?.isdeliverypostaladdressrequired || !flags?.collectbillingaddress){
            setIsChecked(false);
       }
   
     }, [basket])

    return (
        <>   
            <div aria-live="polite" className="screen-reader-only">
                  {textForScreenReader}
            </div>

            {!editMode && flags?.collectbillingaddress && usingLatestBillingDetails?
              
              <div className="item-container">
            
                    <LatestAddress

                        fid={fid}
                        type="billing"
                        selectedCompany={selectedCompany}
                        selectedAddress={selectedAddress}
                        setSelectedAddress={setSelectedAddress}
                        setSelectedCompany={setSelectedCompany}
                        usingLatest={usingLatestBillingDetails}
                        setUsingLatest={setUsingLatestBillingDetails}
                        handleOnChangeAddress={handleOnEdit}
                        showAddressUI={billingAddressUI}
                        collectBilling={flags?.collectbillingaddress}
                        updateAndRefreshBasket={updateAndRefreshBasket}
                        countryList={countryList}
                       //when latest basekt init calls need to be handled by billing
                        ownsLatestBasketInit={!usingLatestDeliveryDetails}

                    />
              </div>

             :
                !usingLatestBillingDetails ? 

                <>

            {(flags?.isdeliverypostaladdressrequired && flags?.collectbillingaddress) ?
                <>
                    <div className="item-container">
                        <div className="item-wrapper">
                            <InputWrapperRefacture
                                id="sameaddress"
                                name="sameaddress"
                                inputWidth="small"
                                type="text"
                                ref={formRef}
                                labelText={t('billingdetails.questionsameaddress')}
                                inputFieldType="checkbox"
                                checked={!isChecked}
                                onChange={() => { setIsChecked(!isChecked) }}
                            />
                        </div>
                    </div>
                    {isChecked && <div className="item-container">
                        <div className="item-wrapper">
                            <div className="detail-wrapper">
                                 {billingAddressUI()}
                            </div>
                        </div>
                     </div>
                    }
                </> : ""}


            {(!isChecked) ? countryField : ""} 
          

            {(!isChecked && flags?.collectbillingaddress) ?
                <AddressFields isChecked={isChecked}
                    vatDetails={vatDetails}
                    setCompanyProperties={setCompanyProperties}
                    companyProperties={companyProperties}
                    addressType="billingAddress"
                    loqateKey={loqateKey}
                    showCompany={showCompany}
                    selectedAddress={selectedAddress}
                    addressStructure={addressStructure}
                    initialFilledState={initialFilledState}
                    setSelectedAddress={setSelectedAddress}
                    selectedCompany={selectedCompany}
                    setSelectedCompany={setSelectedCompany}
                    IsFilled={IsFilled}
                    setIsFilled={setIsFilled}
                    countryCode={countryCode && countryCode}   //passing countryCode for loqate calls.
                    loading={props.loading}
                    updateAndRefreshBasket={updateAndRefreshBasket}
                    hasVatChanged={hasVatChanged}
                    setIsInvalid={setInvalidState}
                    IsInvalid={invalidState}
                    initialInvalidState={initialInvalidState}
                    setFieldsLoading={setFieldsLoading}
                    fieldsLoading={fieldsLoading}
                    billingSectionLoading={billingSectionLoading}
                />
                : ""}

                 </>

                 :""
          
          } 

           

            {/*only shows up if a basket has hidecompanyoncheckout false and country also has company in address fields*/}
            {showCompany && companyProperties && basket ?
                <Company companyList={props.companyList}
                    vatDetails={vatDetails}
                    basket={basket}
                    setBasket={setBasket}
                    fid={fid}
                    setBasketErrors={setBasketErrors}
                    setPaymentElementReload={props.setPaymentElementReload}
                    purchasingFor={purchasingFor}
                    companyProperties={companyProperties}
                    addressType="billingAddress"
                    IsFilled={IsFilled}
                    setIsFilled={setIsFilled}
                    selectedCompany={selectedCompany || props?.deliveryCompany?.COMPANY}
                    setSelectedCompany={setSelectedCompany}
                    setVatChanged={setVatChanged}
                    isVatChecked={props.onVatChecked}
                    isVatApplied={props.onVatApplied}
                    errorStates={errorStates}
                    setErrorStates={setErrorStates}
                    setcompanyProperties={setcompanyProperties }
                    setIsInvalid={setInvalidState}
                    IsInvalid={invalidState}
                    fieldLoading={fieldsLoading}
                    billingSectionLoading={billingSectionLoading}
                    countryCode={countryCode}
                   
            />
            :""}
          
         
        </>
    );
})

